<template>
  <el-dialog
    title="下载"
    :visible.sync="showDownloadModal"
    width="400px"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <el-progress :percentage="downloadPercent" :show-text="false"></el-progress>
    <div slot="footer" class="dialog-footer"></div>
  </el-dialog>
</template>
<script>
export default {
  name: 'Download',
  data() {
    return {
      showDownloadModal: false,
      downloadPercent: 0,
    };
  },
  methods: {
    beginDownload(url, name) {
      if (url.indexOf('?') >= 0) {
        url += '&';
      } else {
        url += '?';
      }
      this.showDownloadModal = true;
      let xhr = new XMLHttpRequest();
      xhr.open('get', url + new Date().getTime());
      xhr.responseType = 'blob';
      xhr.onprogress = (evt) => {
        this.downloadPercent = parseInt((evt.loaded * 100) / evt.total);
      };
      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4 && xhr.status == 200) {
          let blob = xhr.response;
          let blobUrl = URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = blobUrl;
          link.download = name;
          link.click();
          setTimeout(() => {
            this.showDownloadModal = false;
          }, 500);
        }
      };
      xhr.send();
    },
  },
};
</script>
